<template>
    <div>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="4" search :data="taskFiles">

            <div slot="header" v-if="canEdit" class="mb-3">

                <vs-upload :text="$t('UploadFile')" :automatic="true" limit="1" fileName="file" :action="'/api/v1/task/' + taskId + '/file'" @on-success="updateFiles" />

            </div>

            <template slot="thead">
                <vs-th sort-key="user">{{$t("User")}}</vs-th>
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="unit">{{$t("Size")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].user_id">
                        {{ $store.getters.companyUsers[data[index].user_id].name }}
                    </vs-td>

                    <vs-td :data="data[index].file_name">
                        {{ data[index].file_name }}
                    </vs-td>

                    <vs-td :data="data[index].size/1000000">
                        {{(data[index].size/1000000) + "MB"}}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>
        <div v-if="selected.id" class="p-3">

            <vs-divider></vs-divider>
            <div>
                <vs-button color="success" type="border" class="mr-6" @click="downloadFile">{{$t("Download")}}</vs-button>
                <vs-button v-if="this.$store.getters.userData.id === selected.user_id && selected.notes.length > 0" color="warning" type="border" class="mr-6" @click="activeNotesPrompt = true">{{$t("EditNotes")}}</vs-button>
                <vs-button v-else-if="this.$store.getters.userData.id === selected.user_id" color="warning" type="border" class="mr-6" @click="activeNotesPrompt = true">{{$t("AddNotes")}}</vs-button>
                <vs-button v-if="this.$store.getters.userData.id === selected.user_id" color="danger" type="border" class="mt-6" @click="removeFile">{{$t("Delete")}}</vs-button>

            </div>
            <div v-if="selected.notes.length > 0" class="mt-6">
                <h5>{{$t("Notes")}}</h5>
                <p style="white-space: pre-wrap">{{selected.notes}}</p>
            </div>

        </div>

        <vs-popup :title="$t('Edit')" :active.sync="activeNotesPrompt" style="z-index: 54000">
            <div>
                <span>{{$t("Notes")}}</span>
                <vs-textarea v-model="notesEditArea" class="mt-3 w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="saveNotes">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

    </div>
</template>

<script>

    export default {
        props: {
            taskId: {
                type: Number,
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            },
        },
        data() {
            return {
                activeNotesPrompt:false,
                notesEditArea: '',
                selected: {},
                taskFiles: [],
            }
        },
        methods: {
            updateFiles() {
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/file")
                    .then(function (response) {
                        thisIns.taskFiles = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            handleSelected(tr) {
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/file/" + tr.id)
                    .then(function (response) {
                        thisIns.notesEditArea = response.data.notes;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

            },
            saveNotes(){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/file/" + this.selected.id + "/notes", {
                    notes: thisIns.notesEditArea
                }).then(function () {
                    thisIns.updateFiles();
                    thisIns.selected = {};
                    thisIns.activeNotesPrompt = false
                }).catch(function (error) {
                    thisIns.activeNotesPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeFile() {
                const thisIns = this;
                this.$http.delete('/api/v1/task/' + this.taskId + "/file/" + this.selected.id)
                    .then(function () {
                        thisIns.updateFiles();
                        thisIns.selected = {};
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            downloadFile(){
                window.open("/api/v1/task/" + this.taskId + "/file/" + this.selected.id + "/download")
            }
        },
        watch:{
            taskId: function () {
                this.updateFiles();
            }
        },
        created() {

            this.updateFiles();

        }

    }
</script>
